import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class CacheLoggerService {
  constructor(private readonly apollo: Apollo) {}

  logCacheData() {
    const cacheData = this.apollo.client.cache.extract();
    console.log('Cache Data:', cacheData);
  }
}
